import { reactive } from 'vue'
import { apiFetch } from './api'

export interface OfflineEmployee {
  id: string
  name: string
  username: string
  roleId: string
  roleName: string
  photoUrl: string
  createdAt: string
}

const state = reactive({
  items: [] as OfflineEmployee[]
})

export const offlineEmployeesStore = {
  state,
  all() {
    return state.items
  },
  async refresh() {
    state.items = await apiFetch<OfflineEmployee[]>('/offline-employees')
    return state.items
  },
  async save(payload: Partial<OfflineEmployee> & { name: string; username: string }) {
    await apiFetch<{ ok: boolean; employee: OfflineEmployee }>('/offline-employees', {
      method: 'POST',
      body: JSON.stringify(payload)
    })
    await this.refresh()
  },
  async remove(id: string) {
    await apiFetch<{ ok: boolean }>(`/offline-employees/${encodeURIComponent(id)}`, {
      method: 'DELETE'
    })
    await this.refresh()
  }
}
